"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.sendContactForm.name': '联系表单',
    'tools.sendContactForm.description': '从用户消息中收集联系表单数据（姓名、电子邮件、电话、留言）并发送联系请求',
};
